const MFA_INVALID_CODE_MESSAGE =
  "The code doesn't match. Make sure you're using the current code from your authenticator app. Codes change every 30 seconds.";
const MFA_INVALID_BACKUP_CODE_MESSAGE = 'That backup code is invalid or already used. Try another one.';
const MFA_REQUIRED_BY_NETWORK_MESSAGE =
  "Your network requires two-factor authentication, so it can't be turned off. Contact your network admin if you need help.";

const MFA_INVALID_CODE_CODES = new Set(['mfa.invalid_code', 'mfa.reauthentication_failed']);
const MFA_REQUIRED_BY_NETWORK_CODE = 'mfa.required_by_network';

export const isMfaInvalidCodeError = (error) => {
  const code = error?.data?.code;

  if (code === MFA_REQUIRED_BY_NETWORK_CODE) {
    return false;
  }

  if (MFA_INVALID_CODE_CODES.has(code)) {
    return true;
  }

  if (error?.status === 401) {
    return true;
  }

  // Some MFA endpoints return 422 without a structured code for invalid input.
  if (error?.status === 422 && !code) {
    return true;
  }

  return false;
};

export const mapMfaSubmitError = (error, fallback, { useBackupCode } = {}) => {
  if (error?.isInviteMismatch) {
    return error?.data?.error ?? fallback;
  }

  if (error?.data?.code === MFA_REQUIRED_BY_NETWORK_CODE) {
    return MFA_REQUIRED_BY_NETWORK_MESSAGE;
  }

  if (isMfaInvalidCodeError(error)) {
    return useBackupCode ? MFA_INVALID_BACKUP_CODE_MESSAGE : MFA_INVALID_CODE_MESSAGE;
  }

  return fallback;
};
